module.exports = __webpack_public_path__ + "static/StripeDev-5b8982cb6b4608b7f992974571735d3b.png";